import { type ForwardedRef, forwardRef, type HTMLProps, memo } from 'react';

import { useBoolState } from '@didaskill/ui/utils';

import { ImpulseSpinner } from '../../../../general/loading/impulse-spinner/ImpulseSpinner';
import * as styles from './Embedded.styles';

export type EmbeddedProps = Omit<HTMLProps<HTMLDivElement>, 'title' | 'ref'> & {
  src: string;
  title: string;
};

export const EmbeddedBase = forwardRef(
  ({ src, title, children = null, ...props }: EmbeddedProps, ref: ForwardedRef<HTMLDivElement>) => {
    const [isLoading, , onStopLoading] = useBoolState(true);

    return (
      <div {...props} ref={ref} css={styles.embedded}>
        <iframe src={src} title={title} frameBorder={0} allowFullScreen onLoad={onStopLoading} />

        {!!isLoading && (
          <div css={styles.loaderContainer}>
            <ImpulseSpinner />
          </div>
        )}

        {children}
      </div>
    );
  },
);

EmbeddedBase.displayName = 'Embedded';

export const Embedded = memo(EmbeddedBase);
